const marqueeImages = [
  {
    id: "a",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/image-marquee-1.jpg",
    alt: "A photo of a young woman seated in a bright, purple room, surrounded by collectibles next to a teal basketball.",
    aspectRatio: "1/1",
    color: "violet",
  },
  {
    id: "b",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/image-marquee-2.jpg",
    alt: "A photo of two adult men in a garage standing and smiling next to antique globes and stacks of wooden chairs.",
    aspectRatio: "4/5",
    color: "coral",
  },
  {
    id: "l",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/image-marquee-13.jpg",
    alt: "A vintage Batman comic book propped against a wood paneled wall.",
    aspectRatio: "1/1",
    color: "marigold",
  },
  {
    id: "d",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/image-marquee-4.jpg",
    alt: "A photo of a woman with long dark hair putting eBay branded packing tape across a large brown box.",
    aspectRatio: "4/3",
    color: "marigold",
  },
  {
    id: "c",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/image-marquee-3.jpg",
    alt: "A marketing photo of hands handing up a crisp blue denim jacket.",
    aspectRatio: "1/1",
    color: "blue",
  },
  {
    id: "e",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/image-marquee-5.jpg",
    alt: "A photo of two men standing together in front of a seamless backdrop, inside a warehouse.",
    aspectRatio: "4/5",
    color: "coral",
  },
  {
    id: "i",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/image-marquee-14.jpg",
    alt: "A  new Transformers graphic novel standing upright on a vivid red table.",
    aspectRatio: "4/3",
    color: "violet",
  },
  {
    id: "g",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/image-marquee-7.jpg",
    alt: "A close-up photo of hands holding a luxury gold and silver toned metal watch.",
    aspectRatio: "1/1",
    color: "teal",
  },
  {
    id: "i",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/image-marquee-15.jpg",
    alt: "An overhead view of a young person looking through a binder full of Magic: The Gathering trading cards.",
    aspectRatio: "4/3",
    color: "violet",
  },
  {
    id: "f",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/image-marquee-6.jpg",
    alt: "A photo of a man standing proudly in front of a clothing rack.",
    aspectRatio: "4/5",
    color: "blue",
  },
  {
    id: "h",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/image-marquee-8.jpg",
    alt: "A photo of a man and woman standing together smiling, in front of a wall of colorful sneakers.",
    aspectRatio: "4/3",
    color: "coral",
  },
  {
    id: "i",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/image-marquee-9.jpg",
    alt: "Two fashionably dressed young people, smiling, facing off-camera, holding up handbags.",
    aspectRatio: "4/5",
    color: "violet",
  },
  {
    id: "j",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/image-marquee-10.jpg",
    alt: "A collection of 15 fine watches lined up in a bright green case.",
    aspectRatio: "4/3",
    color: "blue",
  },
  {
    id: "l",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/image-marquee-12.jpg",
    alt: "A smiling young man wearing a vintage-style baseball jersey, holding up a signed Mickey Mantle baseball card, warmly lit by sunshine.",
    aspectRatio: "1/1",
    color: "marigold",
  },
  {
    id: "k",
    src: "https://ir.ebaystatic.com/cr/v/c01/ebay-design/image-marquee-11.jpg",
    alt: "A smiling young man taking a photo of a collection of luxury watches while seated in a sunlit home office.",
    aspectRatio: "4/5",
    color: "coral",
  },
];

type MarqueeImage = (typeof marqueeImages)[number];

export { marqueeImages, type MarqueeImage };
